import { render } from "./ProductCard2.vue?vue&type=template&id=73f9007c&scoped=true"
import script from "./ProductCard2.vue?vue&type=script&lang=js"
export * from "./ProductCard2.vue?vue&type=script&lang=js"

import "./ProductCard2.vue?vue&type=style&index=0&id=73f9007c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f9007c"]])

export default __exports__